import { createSlice } from "@reduxjs/toolkit";
import {    home_investment_summeryThunk } from "./thunk";


export const initialState = {
  investmentSummeryData: [],
  investmentSummeryError: {
    code: null,
    message: '',
    data: null
  },
  investmentSummeryLoading: false,
  
  
};

const Home_Investment_Summery = createSlice({
  name: "Home_Investment_Summery",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(home_investment_summeryThunk.pending, (state) => {
      state.investmentSummeryLoading = true ;
      state.investmentSummeryError = initialState.investmentSummeryError; 
      state.investmentSummeryData = []; 
  });
    builder.addCase(home_investment_summeryThunk.fulfilled, (state, action) => {
        state.investmentSummeryData = action.payload.data;
        state.investmentSummeryLoading = false ;
    });
    builder.addCase(home_investment_summeryThunk.rejected, (state, action) => {
      state.investmentSummeryError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.investmentSummeryLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Home_Investment_Summery.actions

export default Home_Investment_Summery.reducer;